/* New Calculators — behaviour for sections/new-calculators.liquid.
   The four calculators' maths is the design's own, unchanged. This file
   only adds: reading the segment/slider controls, writing the visible
   numbers (instantly, as before), and a debounced screen-reader
   announcement per calculator so results are heard without spamming
   assistive tech on every slider tick. */
(function () {
  var $ = function (id) { return document.getElementById(id); };
  var r0 = function (n) { return Math.round(n); };
  var r1 = function (n) { return (Math.round(n * 10) / 10).toFixed(1); };
  var nearest = function (n, s) { return Math.round(n / s) * s; };
  var strip0 = function (s) { return s.replace(/\.0$/, ""); };

  var ACTIVITY = [
    { label: "Rest week", f: 1.2 }, { label: "Light", f: 1.375 }, { label: "Moderate", f: 1.55 },
    { label: "Hard", f: 1.725 }, { label: "Two-a-day", f: 1.9 }
  ];
  var GOALS = [
    { label: "Lose fat", adj: -0.18, pro: 2.2, fat: 0.8, note: "cutting" },
    { label: "Maintain", adj: 0, pro: 1.8, fat: 0.95, note: "maintenance" },
    { label: "Build muscle", adj: 0.12, pro: 2.0, fat: 1.0, note: "lean gaining" }
  ];
  var SWEAT = [0.6, 1.0, 1.5];
  var CLIMATE = [0.85, 1, 1.25];
  var TOL = [{ lo: 2, hi: 3 }, { lo: 3, hi: 5 }, { lo: 5, hi: 6 }];

  var s = { weight: 82, age: 32, height: 178, sex: 0, activity: 2, goal: 1, mins: 60, sweat: 1, climate: 1, phase: 0, tol: 1, coffees: 1 };

  function seg(groupId, key) {
    var wrap = $(groupId);
    if (!wrap) return;
    var btns = wrap.querySelectorAll(".nc-seg");
    for (var k = 0; k < btns.length; k++) btns[k].setAttribute("aria-pressed", btns[k].classList.contains("on") ? "true" : "false");
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        b.addEventListener("click", function () {
          s[key] = +b.getAttribute("data-i");
          for (var j = 0; j < btns.length; j++) { btns[j].classList.toggle("on", btns[j] === b); btns[j].setAttribute("aria-pressed", btns[j] === b ? "true" : "false"); }
          render();
        });
      })(btns[i]);
    }
  }
  function slider(id, key) {
    var el = $(id);
    if (!el) return;
    el.addEventListener("input", function () { s[key] = +el.value; render(); });
  }

  function setText(id, text) { var el = $(id); if (el) el.textContent = text; }

  /* screen-reader summaries: read straight off the numbers render() just
     wrote, rather than recomputing them, so there is one source of truth
     for the maths. Debounced so a slider drag announces once it settles
     instead of on every "input" tick. */
  var announceT = null;
  function scheduleAnnounce() {
    clearTimeout(announceT);
    announceT = setTimeout(announce, 600);
  }
  function announce() {
    setText("nc-status-macros", $("nc-kcal").textContent + " kilocalories a day: " + $("nc-pro").textContent + " protein, " + $("nc-carb").textContent + " carbs, " + $("nc-fat").textContent + " fat.");
    setText("nc-status-hydration", $("nc-litres").textContent + " litres total on a training day: " + $("nc-base").textContent + " baseline, " + $("nc-during").textContent + " per hour training, " + $("nc-sodium").textContent + " sodium to replace.");
    setText("nc-status-creatine", $("nc-credose").textContent + "g a day, " + $("nc-crescoops").textContent + " five-gram scoops.");
    setText("nc-status-caffeine", $("nc-cafrange").textContent + "mg, 45 minutes before you start.");
  }

  function render() {
    var w = s.weight;
    $("nc-bw").textContent = w + " kg";
    $("nc-bw-lbs").textContent = r0(w * 2.2046) + " lb";
    $("nc-age").textContent = s.age + " yrs";
    $("nc-height").textContent = s.height + " cm";
    $("nc-mins").textContent = s.mins + " min";
    $("nc-coffee").textContent = s.coffees + (s.coffees === 1 ? " cup" : " cups");
    /* sliders read out with their units */
    [["nc-bw-range", w + " kilograms"], ["nc-age-range", s.age + " years"], ["nc-height-range", s.height + " centimetres"], ["nc-mins-range", s.mins + " minutes"], ["nc-coffee-range", s.coffees + (s.coffees === 1 ? " cup" : " cups")]].forEach(function (a) { var el = $(a[0]); if (el) el.setAttribute("aria-valuetext", a[1]); });

    /* 01 — macros */
    var g = GOALS[s.goal];
    var bmr = 10 * w + 6.25 * s.height - 5 * s.age + (s.sex === 0 ? 5 : -161);
    var tdee = bmr * ACTIVITY[s.activity].f;
    /* floor the target at 1500 kcal (men) / 1200 kcal (women); protein and fat
       are set per kilo up to 100 kg so a heavy user on a cut is not handed more
       macro calories than the target. Fat gives way (down to 0.5 g/kg) before
       carbs drop below 50 g, and carbs take whatever is left, so the three
       macros always add back up to the headline number. */
    var kcal = Math.max(nearest(tdee * (1 + g.adj), 10), s.sex === 0 ? 1500 : 1200);
    var refW = Math.min(w, 100);
    var proteinG = r0(g.pro * refW);
    var fatG = r0(g.fat * refW);
    if (kcal - proteinG * 4 - fatG * 9 < 200) fatG = Math.max(r0(0.5 * refW), r0((kcal - proteinG * 4 - 200) / 9));
    var carbG = Math.max(0, r0((kcal - proteinG * 4 - fatG * 9) / 4));
    /* three meals at 25 g cover 75 g; the rest from 23 g whey scoops */
    var scoops = Math.max(0, Math.round((proteinG - 75) / 23));
    $("nc-kcal").textContent = kcal.toLocaleString("en-GB");
    $("nc-goalnote").textContent = g.note + " · " + ACTIVITY[s.activity].label.toLowerCase() + " week";
    $("nc-pro").textContent = proteinG + "g";
    $("nc-pronote").textContent = g.pro + " g/kg";
    $("nc-carb").textContent = carbG + "g";
    $("nc-fat").textContent = fatG + "g";
    $("nc-fatnote").textContent = g.fat + " g/kg";
    $("nc-protline").textContent = scoops > 0
      ? "That is " + proteinG + "g of protein a day: three whole-food meals at 25g each, plus roughly " + scoops + " Efectiv shake" + (scoops === 1 ? "" : "s") + " at 22–23g a scoop."
      : "That is " + proteinG + "g of protein a day, which three whole-food meals at 25g each will cover.";

    /* 02 — hydration */
    var rate = SWEAT[s.sweat] * CLIMATE[s.climate];
    var lostL = rate * (s.mins / 60);
    var baselineL = 0.035 * w;
    var duringMl = nearest(rate * 800, 10);
    var sodiumMg = nearest(lostL * 900, 50);
    $("nc-litres").textContent = r1(baselineL + lostL);
    $("nc-base").textContent = r1(baselineL) + "L";
    $("nc-during").textContent = duringMl + "ml";
    $("nc-sodium").textContent = sodiumMg + "mg";
    $("nc-sodnote").textContent = r1(lostL) + "L sweat lost";
    $("nc-hydroline").textContent = "One Efectiv Hydration serving covers " + Math.min(100, r0(400 / Math.max(sodiumMg, 1) * 100)) + "% of that sodium. Split the session fluid into " + Math.max(1, Math.ceil(s.mins / 20)) + " sips across the session rather than drinking it at the end.";

    /* 03 — creatine */
    var loading = s.phase === 0;
    var maint = Math.max(3, nearest(0.1 * w, 0.5));
    var loadDose = nearest(0.3 * w, 1);
    var dose = loading ? loadDose : maint;
    var tubDays = Math.floor(300 / dose);
    $("nc-credose").textContent = strip0(r1(dose));
    $("nc-crewindow").textContent = loading ? "loading phase, days 1–5" : "every day, training or not";
    $("nc-crescoops").textContent = strip0(r1(dose / 5)) + "×";
    $("nc-crescoopnote").textContent = loading ? "split across the day" : (dose <= 5 ? "one scoop a day" : "a day, with any meal");
    $("nc-cresat").textContent = loading ? "5–7 days" : "21–28 days";
    $("nc-cresatnote").textContent = loading ? "then " + maint + "g daily" : "no loading needed";
    $("nc-credays").textContent = tubDays + "d";
    $("nc-creline").textContent = loading
      ? "Split " + strip0(r1(loadDose)) + "g into three or four doses with food for five days, then hold " + maint + "g a day indefinitely."
      : "Take " + maint + "g a day with any meal. Consistency beats timing: a missed day matters more than the hour you take it.";

    /* 04 — caffeine */
    var t = TOL[s.tol];
    var cafLo = nearest(t.lo * w, 5);
    var cafHi = nearest(t.hi * w, 5);
    var fromCoffee = s.coffees * 95;
    var headroom = Math.max(0, 400 - fromCoffee);
    var overCeiling = cafHi > headroom;
    var cafCap = Math.max(0, nearest(Math.min(cafHi, headroom), 5));
    var cafFloor = Math.min(cafLo, Math.max(0, nearest(headroom, 5)));
    /* the 400mg ceiling can squeeze the range to one number: show it once */
    $("nc-cafrange").textContent = cafFloor === cafCap ? String(cafCap) : cafFloor + "–" + cafCap;
    $("nc-cafserv").textContent = strip0(r1(cafCap / 200)) + "×";
    $("nc-cafservnote").textContent = t.lo + "–" + t.hi + " mg/kg range";
    $("nc-cafcoffee").textContent = fromCoffee + "mg";
    $("nc-cafcoffeenote").textContent = s.coffees + " × 95mg";
    $("nc-cafhead").textContent = headroom + "mg";
    $("nc-cafhead").style.color = overCeiling ? "#FF7A5A" : "#FFDD0E";
    $("nc-cafheadnote").textContent = overCeiling ? "top of range too high" : "room for this dose";
    $("nc-cafline").textContent = headroom < 5
      ? "Your coffee has already reached the 400mg daily ceiling, so skip caffeine before training today."
      : overCeiling
      ? "Your coffee has used " + fromCoffee + "mg, so cap the pre-session dose at " + nearest(headroom, 5) + "mg today, or go caffeine-free and keep the ceiling for a session that needs it."
      : "Take it 45 minutes before the first working set. Nothing after 2pm if you want to sleep; the half-life is five to six hours.";

    scheduleAnnounce();
  }

  seg("nc-sex", "sex");
  seg("nc-activity", "activity");
  seg("nc-goal", "goal");
  seg("nc-sweat", "sweat");
  seg("nc-climate", "climate");
  seg("nc-phase", "phase");
  seg("nc-tol", "tol");
  slider("nc-bw-range", "weight");
  slider("nc-age-range", "age");
  slider("nc-height-range", "height");
  slider("nc-mins-range", "mins");
  slider("nc-coffee-range", "coffees");
  render();
})();
